import { selectCommitmentStatuses } from 'legacy/lut/features/partner360/commitment'
import { selectConfigurationState } from 'legacy/lut/features/partner360/configuration'
import { createSelector } from 'reselect'

export const selectCommitmentStatusesByProgramType = createSelector(
  [selectCommitmentStatuses, selectConfigurationState],
  (commitmentStatuses, { programType }) => {
    return commitmentStatuses.find((el) => el.ProgramType === programType)
  }
)
